// extracted by mini-css-extract-plugin
export default {"owm_legend":"useWeatherLayers_owm_legend__X3NI2"};